import React from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import './Policy.scss';

const Policy = ({
	onBackClick,
}) => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const history = useHistory();

  //-------------------------------FUNCTIONS---------------------------------------------------------
  const onClick = () => {
    //history.push(Paths.user.signup);
		if (!!history) {
			history.goBack();
		}
  };

  //-------------------------------RETURN------------------------------------------------------------
  return (
    <>
      <div className="privacy_screen">
        <div className="privacy_content">
          {/* <h3 className="privacy_ttl">
						【エアーインカムライト プライバシーポリシー】
          </h3> */}
          <h3 className="privacy_ttl">
						【アルインコ無線アプリケーション・プライバシーポリシー】
          </h3>
          <div className="privacy_txt">
            <p>
              このアプリケーション・プライバシーポリシー（以下、「本プライバシーポリシー」といいます）は、アルインコ株式会社　電子事業部（以下、「当社」といいます）が提供するスマートフォン用アプリケーション（以下、「本アプリケーション」といいます）および本アプリケーションを通じて提供するサービス（以下、「本サービス」といいます）における利用者情報の取扱いを定めたものです。
              <br />
              なお、利用者情報の提供をご希望されない場合、本アプリケーションおよび本サービスをご利用いただけません。
            </p>
          </div>
          <div className="privacy_list">
            <dl className="list">
              <dt>
                １．利用者情報の取得と利用目的、端末外部へのデータ送信および第三者提供等
              </dt>
              <dd>
                <p className="num">
                  （1）当社は、本アプリケーションおよび本サービスの提供等にあたり、次に掲げる利用者情報をそれぞれ記載の利用目的の達成に必要な範囲で取得し、取扱います。
                </p>
                {/* <h5 className="list_ttl">利用する利用者情報</h5>
								<ul>
									<li><span>GPS位置情報（携帯端末のGPS機能によるもの）</span></li>
									<li><span>利用目的　本アプリケーション、本サービスの提供および改善のため</span></li>
									<li><span>取得方法　アプリケーションによる自動取得</span></li>
									<li><span></span>利用者情報の端末外部へのデータ送信：有</li>
								</ul> */}
                {/* <h5 className="list_ttl">利用する利用者情報</h5> */}
                <p className="num">　　利用する利用者情報</p>
                <p className="num">　　①　ログインID、パスワード</p>
                <ul>
                  {/* <li>
                    <span>ログインID、パスワード</span>
                  </li> */}
                  <li>
                    <span>利用目的：本サービスへのユーザ登録のため</span>
                  </li>
                  <li>
                    <span>取得方法：利用者による入力操作</span>
                  </li>
                  <li>
                    <span>利用者情報の端末外部へのデータ送信：有</span>
                  </li>
                </ul>
                {/* <h5 className="list_ttl">利用する利用者情報</h5> */}
                <p className="num">　　②　通信履歴</p>
                <ul>
                  {/* <li>
                    <span>通信履歴</span>
                  </li> */}
                  <li>
                    <span>
                      利用目的：利用状況の分析・解析及び品質改善のため
                    </span>
                  </li>
                  <li>
                    <span>取得方法：アプリケーションによる自動取得</span>
                  </li>
                  <li>
                    <span>利用者情報の端末外部へのデータ送信：有</span>
                  </li>
                </ul>
                <p className="num">
                  （2）利用者情報の第三者提供
										<p style={{
											marginTop: '-1.2em',
											marginLeft: '-0.8em',
										}}>
											<br />
											利用者情報は次に掲げる場合を除いて、第三者に提供されることはありません。
											<br />
											ただし、以下のいずれかに該当する場合は、本人の権利利益に最大限の配慮を払いつつ、個人情報を第三者に提供する場合があります。
										</p>
                </p>
                <ol>
                  <li>
                    <span className="ol_num">①</span>本人から同意を得た場合
                  </li>
                  <li>
                    <span className="ol_num">②</span>法令に基づく場合
                  </li>
                  <li>
                    <span className="ol_num">③</span>
                    人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合
                  </li>
                  <li>
                    <span className="ol_num">④</span>
                    公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難である場合
                  </li>
                  <li>
                    <span className="ol_num">⑤</span>
                    国の機関もしくは地方公共団体またはその委託を受けたものが、法令の定めにより遂行することに協力する必要がある場合であって、本人の同意を得ることによりその遂行に支障を及ぼすおそれがある場合
                  </li>
                  <li>
                    <span className="ol_num">⑥</span>
                    利用者情報を個人が識別されない形式のデータに加工した場合
                  </li>
                </ol>
              </dd>
            </dl>
            <dl className="list">
              <dt>２．利用者情報の取得・蓄積・利用に関する同意</dt>
              <dd>
                <p>
                  本アプリケーションおよび本サービスは、本プライバシーポリシーおよび本サービス利用規約をご確認いただき、内容をご理解したうえでご利用ください。ご利用者は本アプリケーションをインストールする際に、本プライバシーポリシーをご確認ください。
                </p>
              </dd>
            </dl>
            <dl className="list">
              <dt>３．利用者情報の取得停止等</dt>
              <dd>
                <p className="num">
                  （1）上記１．に定める規定に基づき、取得した利用者情報の内容に関し、照会／訂正／削除等を希望される場合は、下記窓口までご連絡くださいますようお願いします。
                </p>
                <p className="num">
                  （2）ご利用者が本アプリケーションの削除(以下「アンインストール」という)機能を利用して端末より本アプリケーションをアンインストールされた場合、利用者情報は全て端末内より削除され、本サービス解約後に本サービス上のサーバからは適切な管理のもと定期的なメンテナンス時に廃棄されます。
                </p>
              </dd>
            </dl>
            <dl className="list">
              <dt>４．本プライバシーポリシーの公開　</dt>
              <dd>
                <p>
                  本プライバシーポリシーは、本アプリケーションおよび本サービスのみに適用されます。
                  <br />
                  本プライバシーポリシーは本アプリケーションインストール及びアップデートの画面に公開いたします。また、本プライバシーポリシーは当社Webページに公開いたします。
                </p>
              </dd>
            </dl>
            <dl className="list">
              <dt>５．利用者情報の取り扱いに関する問い合わせ窓口</dt>
              <dd>
                <p>
                  本アプリケーションおよび本サービスにおける利用者情報の取扱いに関して、ご意見・ご要望がございましたら、下記窓口までご連絡くださいますようお願いします。
                </p>
                <p>
                  窓口名称：アルインコ株式会社　電子事業部　アルインコクラウドサービス係
                  <br />
                  連絡先　：E-Mail　alinco_cloudservice@alinco.co.jp
                </p>
              </dd>
            </dl>
            <dl className="list">
              <dt>６．本プライバシーポリシーの変更</dt>
              <dd>
                <p className="num">
                  （1）当社は、本アプリケーションのバージョンアップまたは法令の変更等に伴い、本プライバシーポリシーを変更することがあります。
                </p>
                <p className="num">
                  （2）当社は、本プライバシーポリシーについて変更した場合には、当社ウェブサイトへの掲載をもってお客様へ通知いたします。ただし、重要なものについては当社所定の方法でお客様の同意を得るものといたします。
                </p>
              </dd>
            </dl>
            {/* <div className="privacy_contact">
							<div className="ttl">このページの内容に関するご質問は、右記窓口でお受け付けております。</div>
							<div className="button"><a href="https://alinco-denshi.com/contact.html">お問い合わせはこちら</a></div>
						</div> */}
          </div>
          {((!!history && (history.length > 1)) || !!onBackClick) && (<div className="privacy_button">
            <Button
							className="button"
							onClick={!!onBackClick ? onBackClick:onClick}
						>
              戻る
            </Button>
          </div>)}
        </div>
      </div>
    </>
  );
};

export default Policy;
